"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
Object.defineProperty(exports, "firebase", {
  enumerable: true,
  get: function get() {
    return _firebase["default"];
  }
});
Object.defineProperty(exports, "mainFirebase", {
  enumerable: true,
  get: function get() {
    return _firebase.firebase;
  }
});
Object.defineProperty(exports, "store", {
  enumerable: true,
  get: function get() {
    return _store.store;
  }
});
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _firebase = _interopRequireWildcard(require("./firebase.config"));
var _store = require("../store");
var _common = require("../common");
var _collectame = _interopRequireWildcard(require("../collectame"));
var _autodocs = _interopRequireWildcard(require("../autodocs"));
var _workflux = _interopRequireWildcard(require("../workflux"));
var _dokia = _interopRequireWildcard(require("../dokia"));
var _axios = _interopRequireDefault(require("axios"));
var _Code2faValidation = _interopRequireDefault(require("../../@components/Code2faValidation"));
var _functions = require("../../@functions");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var appcenterProdRoute = "https://api-customer.taugor.app/";
var axiosInstance = function axiosInstance() {
  return _axios["default"].create({
    baseURL: process.env.API_PROD ? appcenterProdRoute : (0, _functions.isLocal)() ? 'http://localhost:5001' : appcenterProdRoute,
    timeout: 240000
  });
};
var appcenterService = axiosInstance();
var userCollection = _firebase["default"].firestore().collection('user');
var groupCollection = _firebase["default"].firestore().collection('group');
var companyCollection = _firebase["default"].firestore().collection('company');
var chatCollection = _firebase["default"].firestore().collection('chat');
var licenseCollection = _firebase["default"].firestore().collection('license');
var accessRequestCollection = _firebase["default"].firestore().collection('accessRequest');
var types = {
  authUpdate: 'appcenter@auth-update',
  userUpdate: 'appcenter@user-update',
  usersUpdate: 'appcenter@users-update',
  companyUpdate: 'appcenter@company-update',
  groupsUpdate: 'appcenter@groups-update',
  chatsUpdate: 'appcenter@chats-update',
  licensesUpdate: 'appcenter@licenses-update',
  accessRequestsUpdate: 'appcenter@access-request-update',
  permissionsUpdate: 'appcenter@permissions-update',
  update: 'appcenter@update'
};
// const storedState = JSON.parse(localStorage.getItem(storeKey)) || {}
var storedState = {};
var createInitialState = function createInitialState(storedState) {
  return _objectSpread({
    users: [],
    chats: [],
    groups: [],
    user: {},
    company: {},
    permissions: [],
    authenticated: false,
    isAuthContextCreated: false,
    licenses: [],
    accessRequests: [],
    personalAccessRequests: [],
    customToken: '',
    tokens: {}
  }, storedState);
};
var INITIAL_STATE = createInitialState(storedState);
var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var getState = function getState(oState, action) {
    switch (action.type) {
      case types.update:
        return _objectSpread({}, oState);
      case types.permissionsUpdate:
        return _objectSpread(_objectSpread({}, oState), {}, {
          permissions: action.permission
        });
      case types.accessRequestsUpdate:
        return _objectSpread(_objectSpread({}, oState), {}, {
          accessRequests: action.accessRequests
        });
      case types.licensesUpdate:
        return _objectSpread(_objectSpread({}, oState), {}, {
          licenses: action.licenses
        });
      case types.chatsUpdate:
        return _objectSpread(_objectSpread({}, oState), {}, {
          chats: action.chats
        });
      case types.groupsUpdate:
        {
          return _objectSpread(_objectSpread({}, oState), {}, {
            groups: action.groups
          });
        }
      case types.companyUpdate:
        return _objectSpread(_objectSpread({}, oState), {}, {
          company: action.company
        });
      case types.usersUpdate:
        return _objectSpread(_objectSpread({}, oState), {}, {
          users: action.users
        });
      case types.userUpdate:
        return _objectSpread(_objectSpread({}, oState), {}, {
          user: action.user
        });
      case types.authUpdate:
        return _objectSpread(_objectSpread({}, oState), {}, {
          authenticated: action.authenticated,
          returnedToken: action.returnedToken,
          token: action.token
        });
      case 'logout':
        return createInitialState({});
      default:
        return _objectSpread({}, oState);
    }
  };
  var authStateCreated = state.isAuthContextCreated;
  var finalState = getState(state, action);
  if (!finalState.authenticated) {
    finalState = createInitialState({
      isAuthContextCreated: finalState.isAuthContextCreated
    });
  }
  if (authStateCreated) {
    finalState.isAuthContextCreated = authStateCreated;
  }

  // localStorage.setItem(storeKey, JSON.stringify(finalState))
  return finalState;
};
var getCurrentState = function getCurrentState() {
  return _store.store.getState().appcenter;
};
var api = function api() {
  var subscriptions = {
    login: [],
    logout: []
  };
  var snapshots = [];
  var getBasicStructure = function getBasicStructure(uid) {
    service.users.get(uid, function (user) {
      service.company.get(user.companies[0], function (company) {
        var state = getCurrentState();
        state.company = company;
        if (user.companyadmin) {
          service.company.accessRequests.list();
        }
        service.company.accessRequests.personal.list();
        service.company.licenses.list();
        service.company.groups.list();
        service.users.list();
        service.users.chats.sync();
      });
    });
  };
  var createChat = function createChat(state, participants, actives, title, groupChat) {
    var doc = chatCollection.doc();
    var message = {
      uid: doc.id,
      participants: participants,
      actives: actives,
      company: state.company.uid,
      createdAt: new Date(),
      createdBy: state.user.uid,
      deleted: false,
      active: true,
      title: title,
      groupChat: !!groupChat,
      lastMessage: {
        date: new Date(),
        message: '',
        user: {
          name: state.user.firstName + ' ' + state.user.lastName,
          uid: state.user.uid
        }
      }
    };
    doc.set(message).then(function (r) {
      service.users.chats.messages.send(message, state.user.firstName + ' ' + state.user.lastName + ' entrou na conversa');
    });
  };
  var postAuth = function postAuth(app) {
    return /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(result) {
        var state, signInWith2fa, promise, twoFaValidated, permissions;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              state = getCurrentState();
              state.customToken = result.data.customToken;
              signInWith2fa = !!result.data.user.signInWith2fa;
              if (!signInWith2fa) {
                _context.next = 11;
                break;
              }
              promise = new Promise(function (resolve) {
                _store.services.message.show('Aut. de Duas Etapas', /*#__PURE__*/_react["default"].createElement(_Code2faValidation["default"], {
                  user: result.data.user,
                  onCancel: function onCancel() {
                    return resolve(false);
                  },
                  onCodeValidated: function onCodeValidated() {
                    return resolve(true);
                  }
                }));
              });
              _context.next = 7;
              return promise;
            case 7:
              twoFaValidated = _context.sent;
              _store.services.message.hide();
              if (twoFaValidated) {
                _context.next = 11;
                break;
              }
              return _context.abrupt("return", result.data);
            case 11:
              _firebase["default"].auth().setPersistence(_firebase.firebase.auth.Auth.Persistence.LOCAL);
              _collectame.firebase.auth().setPersistence(_firebase.firebase.auth.Auth.Persistence.LOCAL);
              _autodocs.firebase.auth().setPersistence(_firebase.firebase.auth.Auth.Persistence.LOCAL);
              _workflux.firebase.auth().setPersistence(_firebase.firebase.auth.Auth.Persistence.LOCAL);
              _dokia.firebaseNewton.auth().setPersistence(_firebase.firebase.auth.Auth.Persistence.LOCAL);
              state.authenticated = true;
              state.user = result.data.user;
              state.company = result.data.user.companies[0];
              state.app = app;
              permissions = [];
              state.user.groups.map(function (g) {
                if (!g.permissions) return;
                g.permissions.map(function (p) {
                  if (permissions.indexOf(p) > -1) return;
                  permissions.push(p);
                });
              });
              state.permissions = permissions;
              _context.next = 25;
              return Promise.all([_collectame["default"].auth.login.token(result.data.tokens.collectame), _autodocs["default"].auth.login.token(result.data.tokens.autodocs), _workflux["default"].auth.login.token(result.data.tokens.workflux), _dokia["default"].auth.login.multiple.newton(result.data.tokens.dokiaNewton), _firebase["default"].auth().signInWithCustomToken(result.data.tokens.appcenterCustomer)]);
            case 25:
              return _context.abrupt("return", result.data);
            case 26:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  };
  var fixApp = function fixApp(app) {
    if (['dokia-adesc', 'dokia-newton'].indexOf(app) > -1) return 'dokia';
    if (['workflux-portal'].indexOf(app) > -1) return 'workflux';
    if (['lawdoc', 'autodocs'].indexOf(app) > -1) return 'autodocs';
    return app;
  };
  var service = {
    axios: axiosInstance,
    subscribe: {
      logout: function logout(callback) {
        subscriptions.logout.push(callback);
        return function () {
          var index = -1;
          subscriptions.logout.map(function (cb, i) {
            if (cb === callback) {
              index = i;
            }
          });
          if (index > -1) {
            subscriptions.logout.splice(index, 1);
          }
        };
      }
    },
    auth: {
      anonymous: function anonymous(app) {
        return appcenterService.post("/authentication/".concat(app, "/anonymous")).then(function (result) {
          var state = getCurrentState();
          _firebase["default"].auth().setPersistence(_firebase.firebase.auth.Auth.Persistence.LOCAL);
          _collectame.firebase.auth().setPersistence(_firebase.firebase.auth.Auth.Persistence.LOCAL);
          _autodocs.firebase.auth().setPersistence(_firebase.firebase.auth.Auth.Persistence.LOCAL);
          _workflux.firebase.auth().setPersistence(_firebase.firebase.auth.Auth.Persistence.LOCAL);
          _dokia.firebaseNewton.auth().setPersistence(_firebase.firebase.auth.Auth.Persistence.LOCAL);
          var promise = Promise.resolve();
          if (['collectame'].indexOf(app) > -1) {
            promise = _collectame["default"].auth.login.token(result.data);
          }
          if (['autodocs', 'lawdocs'].indexOf(app) > -1) {
            promise = _autodocs["default"].auth.login.token(result.data);
          }
          if (['workflux'].indexOf(app) > -1) {
            promise = _workflux["default"].auth.login.token(result.data);
          }
          if (['dokia-adesc'].indexOf(app) > -1) {
            promise = _dokia["default"].auth.login.multiple.adesc(result.data);
          }
          if (['dokia', 'dokia-newton'].indexOf(app) > -1) {
            promise = _dokia["default"].auth.login.multiple.newton(result.data);
          }
          if (['appcenter-customer'].indexOf(app) > -1) {
            promise = _firebase["default"].auth().signInWithCustomToken(result.data);
          }
          state.company = {
            uid: 'anonymous'
          };
          return promise;
        });
      },
      app: function app(_app, userOrToken, password, company) {
        var newApp = fixApp(_app);
        return appcenterService.post("/authentication/".concat(newApp), {
          user: userOrToken,
          password: password,
          company: company,
          all: true
        }).then(postAuth(newApp))["catch"](function (r) {
          //('ERRORDATA', r)
          return Promise.reject(r);
        });
      },
      appWithCertificate: function appWithCertificate(app, cpf, certificate) {
        var newApp = fixApp(app);
        return appcenterService.post("/authentication/".concat(newApp), {
          cpf: cpf,
          certificate: certificate,
          all: true
        }).then(postAuth(newApp))["catch"](function (r) {
          //('ERRORDATA', r)
          return Promise.reject(r);
        });
      },
      appWithGoogle: function appWithGoogle(app, token, company) {
        var newApp = fixApp(app);
        return appcenterService.post("/authentication/".concat(newApp), {
          token: token,
          typeProvider: 'google',
          company: company,
          all: true
        }).then(postAuth(newApp))["catch"](function (r) {
          return Promise.reject(r);
        });
      },
      appWithLinkedIn: function appWithLinkedIn(app, token, company) {
        var newApp = fixApp(app);
        var domain = location.origin;
        return appcenterService.post("/authentication/".concat(newApp), {
          token: token,
          typeProvider: 'linkedin',
          company: company,
          domain: domain,
          all: true
        }).then(postAuth(newApp))["catch"](function (r) {
          return Promise.reject(r);
        });
      },
      sso: function sso(app) {
        if (!app) return;
        var state = getCurrentState();
        if (!state.authenticated) return;
        var newApp = fixApp(app);
        var url = '';
        switch (newApp) {
          case 'collectame':
            url = 'https://yopen.pro';
            if ((0, _functions.isLocal)()) url = 'http://localhost:3000';
            break;
          case 'workflux-portal':
          case 'workflux':
            url = 'https://workflux.digital';
            if ((0, _functions.isLocal)()) url = 'http://localhost:3005';
            break;
          case 'autodocs':
            url = 'https://editfy.app';
            if ((0, _functions.isLocal)()) url = 'http://localhost:3002';
            break;
          case 'dokia':
          case 'dokia-adesc':
          case 'dokia-newton':
            url = 'https://dok.plus';
            if ((0, _functions.isLocal)()) url = 'http://localhost:3006';
            break;
        }
        return appcenterService.post("/authentication/sso/".concat(state.company.uid, "/").concat(app, "/").concat(state.user.uid)).then(function (response) {
          window.open(url + '/sso/' + response.data.uid, '_blank');
        });
      },
      /**
       * Will identify if there is an active login on the current application
       * If true, will attempt to login on the appcenter firebase instance
       * using the stored token
       */

      sync: function sync() {
        _firebase["default"].auth().onAuthStateChanged(function (user) {
          var state = getCurrentState();
          if (!state.isAuthContextCreated) {
            state.isAuthContextCreated = true;
          }
          if (user) {
            state.authenticated = true;
            getBasicStructure(user.uid);
          }
          _store.store.dispatch({
            type: types.update
          });
        });
      },
      /**
       * Attempt to login on appcenter firebase instance with a custom token
       */
      login: function login(token) {
        _firebase["default"].auth().signInWithCustomToken(token)["catch"](function (e) {
          //('AUTH ERROR', e)
          if (e && e.code === 'auth/invalid-custom-token') {
            service.auth.logout();
          }
        });
      },
      /**
       * Will log out of all applications
       */
      logout: function () {
        var _logout = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
          var state, app, user;
          return _regenerator["default"].wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                state = getCurrentState();
                app = fixApp(state.app);
                user = state.user.uid;
                _context2.next = 5;
                return _firebase["default"].auth().signOut();
              case 5:
                _context2.next = 7;
                return _collectame["default"].auth.logout();
              case 7:
                _context2.next = 9;
                return _workflux["default"].auth.logout();
              case 9:
                _context2.next = 11;
                return _dokia["default"].auth.logout();
              case 11:
                _store.store.dispatch({
                  type: 'logout'
                });
                subscriptions.logout.map(function (callback) {
                  if (typeof callback === 'function') callback();
                });
                snapshots.map(function (unsubscribe) {
                  if (typeof unsubscribe === 'function') {
                    unsubscribe();
                  }
                });
                if (!(user && app)) {
                  _context2.next = 18;
                  break;
                }
                return _context2.abrupt("return", appcenterService.post("/unauthentication/".concat(app), {
                  user: user
                }));
              case 18:
                return _context2.abrupt("return", Promise.resolve());
              case 19:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function logout() {
          return _logout.apply(this, arguments);
        }
        return logout;
      }(),
      recoverPassword: function recoverPassword(user) {
        return appcenterService.post("/authentication/recover/password", {
          user: user
        });
      },
      validate: {
        recoveryToken: function recoveryToken(token) {
          return appcenterService.post("/authentication/recover/password/validate", {
            token: token
          }).then(function (result) {
            return result.data;
          });
        }
      }
    },
    company: {
      /**
       * Gets a company from server
       */
      get: function get(uid, callback) {
        if (!uid) return;
        var state = getCurrentState();
        if (!state.authenticated) return;
        snapshots.push(companyCollection.doc(uid).onSnapshot(function (doc) {
          var state = getCurrentState();
          if (!doc.exists) return;
          var data = doc.data();
          delete data.$$index;
          delete data._index_;
          if (callback) callback(data);
          state.company = data;
          _store.store.dispatch({
            type: types.update
          });
        }));
      },
      warehouseOwnedList: function warehouseOwnedList(callback) {
        var state = getCurrentState();
        if (!state.authenticated) return;
        snapshots.push(companyCollection.where('warehouseOwner', '==', state.company.uid).get().then(function (snapshot) {
          if (typeof callback == 'function') callback(snapshot.docs);
        }));
      },
      licenses: {
        list: function list(callback) {
          var state = getCurrentState();
          if (!state.authenticated) return;
          snapshots.push(licenseCollection.where('company', '==', state.company.uid).where('deleted', '==', false).onSnapshot(function (snapshot) {
            var state = getCurrentState();
            var data = snapshot.docs.map(function (d) {
              return d.data();
            });
            if (callback) return callback(data);
            state.licenses = data;
            _store.store.dispatch({
              type: types.update
            });
          }));
        }
      },
      groups: {
        list: function list(callback) {
          var state = getCurrentState();
          if (!state.authenticated) return;
          snapshots.push(groupCollection.where('company', '==', state.company.uid).where('deleted', '==', false).onSnapshot(function (snapshot) {
            var state = getCurrentState();
            var data = snapshot.docs.map(function (d) {
              return d.data();
            });
            if (callback) callback(data);
            var permissions = [];
            data.map(function (g) {
              delete g.$$index;
              if (!g.permissions || g.members.indexOf(state.user.uid) == -1) return;
              g.permissions.map(function (p) {
                if (permissions.indexOf(p) > -1) return;
                permissions.push(p);
              });
            });
            state.permissions = permissions;
            state.groups = data;
            _store.store.dispatch({
              type: types.update
            });
          }));
        }
      },
      accessRequests: {
        decide: function decide(uid, status) {
          var _accessRequestCollect;
          var state = getCurrentState();
          if (!state.authenticated) return;
          accessRequestCollection.doc(uid).update((_accessRequestCollect = {
            status: status
          }, (0, _defineProperty2["default"])(_accessRequestCollect, "".concat(status, "Date"), new Date()), (0, _defineProperty2["default"])(_accessRequestCollect, "statusReponsible", {
            name: state.user.firstName + ' ' + state.user.lastName,
            uid: state.user.uid
          }), _accessRequestCollect));
          accessRequestCollection.doc(uid).collection('history').doc().set({
            decision: status,
            user: {
              name: state.user.firstName + ' ' + state.user.lastName,
              uid: state.user.uid
            }
          });
        },
        toggleActive: function toggleActive(request) {
          var state = getCurrentState();
          if (!state.authenticated) return;
          var active = !request.active;
          var oPromise = Promise.resolve();
          if (active) {
            oPromise = new Promise( /*#__PURE__*/function () {
              var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(resolve) {
                var licenses, groups, users;
                return _regenerator["default"].wrap(function _callee3$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.next = 2;
                      return licenseCollection.where('company', '==', request.company).where('deleted', '==', false).get().then(function (s) {
                        return s.docs.map(function (d) {
                          return d.data();
                        });
                      });
                    case 2:
                      licenses = _context3.sent;
                      _context3.next = 5;
                      return groupCollection.where('company', '==', request.company).where('deleted', '==', false).get().then(function (s) {
                        return s.docs.map(function (d) {
                          return d.data();
                        });
                      });
                    case 5:
                      groups = _context3.sent;
                      _context3.next = 8;
                      return userCollection.where('companies', 'array-contains', request.company).where('deleted', '==', false).get().then(function (s) {
                        return s.docs.map(function (d) {
                          return d.data();
                        });
                      });
                    case 8:
                      users = _context3.sent;
                      resolve({
                        licenses: licenses,
                        groups: groups,
                        users: users
                      });
                    case 10:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3);
              }));
              return function (_x2) {
                return _ref2.apply(this, arguments);
              };
            }());
          }
          oPromise.then(function (response) {
            var updateObject = {
              active: active
            };
            if (active) {
              updateObject.users = response.users;
              updateObject.licenses = response.licenses;
              updateObject.groups = response.groups;
            }
            accessRequestCollection.doc(request.uid).update(updateObject);
            accessRequestCollection.doc(request.uid).collection('history').doc().set({
              active: active,
              user: {
                name: state.user.firstName + ' ' + state.user.lastName,
                uid: state.user.uid
              }
            });
          });
        },
        list: function list(callback) {
          var state = getCurrentState();
          if (!state.authenticated) return;
          snapshots.push(accessRequestCollection.where('company', '==', state.company.uid).where('deleted', '==', false).where('status', 'in', ['pending', 'accepted']).onSnapshot(function (snapshot) {
            var state = getCurrentState();
            var data = snapshot.docs.map(function (d) {
              return d.data();
            });
            if (callback) return callback(data);
            state.accessRequests = data;
            _store.store.dispatch({
              type: types.update
            });
          }));
        },
        personal: {
          list: function list(callback) {
            var state = getCurrentState();
            if (!state.authenticated) return;
            snapshots.push(accessRequestCollection.where('user.uid', '==', state.user.uid).where('deleted', '==', false).where('status', 'in', ['pending', 'accepted']).onSnapshot(function (snapshot) {
              var state = getCurrentState();
              var data = snapshot.docs.map(function (d) {
                return d.data();
              });
              if (callback) return callback(data);
              state.personalAccessRequests = data;
              _store.store.dispatch({
                type: types.update
              });
            }));
          }
        }
      }
    },
    users: {
      get: function get(uid, callback) {
        if (!uid) return;
        var state = getCurrentState();
        if (!state.authenticated) return;
        snapshots.push(userCollection.doc(uid).onSnapshot(function (doc) {
          var state = getCurrentState();
          if (!doc.exists) return;
          var data = doc.data();
          delete data.password;
          delete data.salt;
          delete data.$$index;
          if (callback) callback(data);
          state.user = data;
          _store.store.dispatch({
            type: types.update
          });
        }));
      },
      list: function list(callback) {
        var state = getCurrentState();
        if (!state.authenticated) return;
        var subscription = userCollection.where('companies', 'array-contains-any', [state.company.uid]).where('deleted', '==', false)
        // .where('emailVerified', '==', true)
        // .select(...userFields)
        .onSnapshot(function (snapshot) {
          var state = getCurrentState();
          var users = snapshot.docs.map(function (d) {
            return d.data();
          });
          if (callback) callback(users);
          state.users = users.map(function (user) {
            delete user.password;
            delete user.salt;
            delete user.$$index;
            return user;
          });
          _store.store.dispatch({
            type: types.update
          });
        });
        snapshots.push(subscription);
        return subscription;
      },
      chats: {
        messages: {
          send: function send(chat, message, preventCurrent) {
            var state = getCurrentState();
            if (!state.authenticated) return;
            var chatDoc = chatCollection.doc(chat.uid);
            var doc = chatDoc.collection('messages').doc();
            var activeDate = new Date();
            var messageDate = new Date();
            messageDate.setSeconds(messageDate.getSeconds() + 1);
            var oMessage = {
              uid: doc.id,
              date: messageDate,
              message: message,
              user: {
                name: state.user.firstName + ' ' + state.user.lastName,
                uid: state.user.uid
              }
            };
            var payload = {
              lastMessage: oMessage
            };
            if (chat.groupChat) {
              payload.actives = {};
              state.groups.map(function (group) {
                if (!chat.participants[group.uid]) return;
                group.members.map(function (uid) {
                  if (uid == state.user.uid && preventCurrent) {
                    return;
                  }
                  payload.actives[uid] = activeDate;
                });
              });
            } else {
              payload.actives = {};
              Object.keys(chat.actives).map(function (uid) {
                payload.actives[uid] = chat.actives[uid] ? (0, _common.toDate)(chat.actives[uid]) : activeDate;
              });
            }
            chatDoc.update(payload);
            // state.messages.push(state.messages)
            _store.store.dispatch({
              type: types.update
            });
            doc.set(oMessage);
          },
          list: function list(uid, limit, last, callback) {
            var state = getCurrentState();
            if (!state.authenticated) return;
            var query = chatCollection.doc(uid).collection('messages').orderBy('date', 'desc');
            if (last) {
              query = query.startAfter(last);
            }
            return query.limit(limit).onSnapshot(function (snapshot) {
              var data = snapshot.docs.map(function (d) {
                return d.data();
              });
              if (callback) callback(data);
              return data;
            });
          },
          update: function update(chat, message) {
            var state = getCurrentState();
            if (!state.authenticated) return;
            //('message', message)
            chatCollection.doc(chat.uid).collection('messages').doc(message.uid).update(message);
          }
        },
        updateActive: function updateActive(chat) {
          var state = getCurrentState();
          if (!state.authenticated) return;
          chatCollection.doc(chat.uid).update((0, _defineProperty2["default"])({}, "actives.".concat(state.user.uid), new Date()));
        },
        leave: function leave(chat) {
          var state = getCurrentState();
          if (!state.authenticated) return;
          setTimeout(function () {
            chatCollection.doc(chat.uid).update((0, _defineProperty2["default"])({}, "actives.".concat(state.user.uid), false));
          }, 100);
        },
        get: function get(uid, callback) {
          var state = getCurrentState();
          if (!state.authenticated) return;
          chatCollection.doc(uid).get().then(function (doc) {
            if (!doc.exists) return;
            var data = doc.data();
            if (callback) callback(data);
          });
        },
        sync: function sync() {
          var state = getCurrentState();
          if (!state.authenticated) return;
          var query = chatCollection.where("actives.".concat(state.user.uid), '!=', false);
          query.onSnapshot(function (snapshot) {
            var state = getCurrentState();
            state.chats = snapshot.docs.map(function (d) {
              return d.data();
            });
            _store.store.dispatch({
              type: types.update
            });
          });
        },
        createFromUser: function () {
          var _createFromUser = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(user) {
            var _createChat, _createChat2;
            var state, existing;
            return _regenerator["default"].wrap(function _callee4$(_context4) {
              while (1) switch (_context4.prev = _context4.next) {
                case 0:
                  state = getCurrentState();
                  if (state.authenticated) {
                    _context4.next = 3;
                    break;
                  }
                  return _context4.abrupt("return");
                case 3:
                  _context4.next = 5;
                  return chatCollection.where("participants.".concat(user.uid), '==', true).where("participants.".concat(state.user.uid), '==', true).where('company', '==', state.company.uid).get().then(function (snapshot) {
                    return snapshot.docs.map(function (d) {
                      return d.data();
                    });
                  });
                case 5:
                  existing = _context4.sent;
                  if (!existing.length) {
                    _context4.next = 9;
                    break;
                  }
                  existing.map(function (chat) {
                    var _chatCollection$doc$u3;
                    if (!chat.actives[state.user.uid]) {
                      service.users.chats.messages.send(chat, state.user.firstName + ' ' + state.user.lastName + ' entrou na conversa', true);
                    }
                    chatCollection.doc(chat.uid).update((_chatCollection$doc$u3 = {
                      active: true,
                      deleted: false
                    }, (0, _defineProperty2["default"])(_chatCollection$doc$u3, "actives.".concat(state.user.uid), new Date()), (0, _defineProperty2["default"])(_chatCollection$doc$u3, "actives.".concat(user.uid), new Date()), _chatCollection$doc$u3));
                  });
                  return _context4.abrupt("return");
                case 9:
                  createChat(state, (_createChat = {}, (0, _defineProperty2["default"])(_createChat, state.user.uid, true), (0, _defineProperty2["default"])(_createChat, user.uid, true), _createChat), (_createChat2 = {}, (0, _defineProperty2["default"])(_createChat2, state.user.uid, new Date()), (0, _defineProperty2["default"])(_createChat2, user.uid, false), _createChat2), user.firstName + ' + ' + state.user.firstName);
                case 10:
                case "end":
                  return _context4.stop();
              }
            }, _callee4);
          }));
          function createFromUser(_x3) {
            return _createFromUser.apply(this, arguments);
          }
          return createFromUser;
        }(),
        createFromGroup: function () {
          var _createFromGroup = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(group) {
            var state, existing, actives;
            return _regenerator["default"].wrap(function _callee5$(_context5) {
              while (1) switch (_context5.prev = _context5.next) {
                case 0:
                  state = getCurrentState();
                  if (state.authenticated) {
                    _context5.next = 3;
                    break;
                  }
                  return _context5.abrupt("return");
                case 3:
                  _context5.next = 5;
                  return chatCollection.where("participants.".concat(group.uid), '==', true).where('company', '==', state.company.uid).get().then(function (snapshot) {
                    return snapshot.docs.map(function (d) {
                      return d.data();
                    });
                  });
                case 5:
                  existing = _context5.sent;
                  if (!existing.length) {
                    _context5.next = 9;
                    break;
                  }
                  existing.map(function (chat) {
                    if (!chat.actives[state.user.uid]) {
                      service.users.chats.messages.send(chat, state.user.firstName + ' ' + state.user.lastName + ' entrou na conversa');
                    }
                    chatCollection.doc(chat.uid).update((0, _defineProperty2["default"])({
                      active: true,
                      deleted: false
                    }, "actives.".concat(state.user.uid), new Date()));
                  });
                  return _context5.abrupt("return");
                case 9:
                  actives = {};
                  group.members.map(function (uid) {
                    actives[uid] = false;
                  });
                  actives[state.user.uid] = new Date();
                  createChat(state, (0, _defineProperty2["default"])({}, group.uid, true), actives, group.name, true);
                case 13:
                case "end":
                  return _context5.stop();
              }
            }, _callee5);
          }));
          function createFromGroup(_x4) {
            return _createFromGroup.apply(this, arguments);
          }
          return createFromGroup;
        }()
      }
    }
  };
  return service;
};
var appcenter = api();
_store.store.injectReducer('appcenter', reducer, appcenter);
var _default = appcenter;
exports["default"] = _default;